<script lang="ts">
import { onMount } from "svelte";
import { fetchResearchItems } from "../services/research";
import { loadImageWithFallback } from "../utils";
import { fade } from "svelte/transition";
import { quintOut } from "svelte/easing";

export let id: string;

const researchFetch = new Promise(async (resolve: (data: any[]) => void) => {
    let data = await fetchResearchItems();
    resolve(data);
});

onMount(async () => {
    data = await researchFetch;
})

let data = null;
let noResults = true;

$: if (data !== null) { 
    data.forEach(category => {
        if (!noResults) return;
        let filterd = category.items.filter(item => item.id == id);
        noResults = filterd.length <= 0;
    })
}

</script>

{#await researchFetch}
    <div class="content">
        <div class="loading-cube-grid">
            <div class="sk-cube sk-cube1"></div>
            <div class="sk-cube sk-cube2"></div>
            <div class="sk-cube sk-cube3"></div>
            <div class="sk-cube sk-cube4"></div>
            <div class="sk-cube sk-cube5"></div>
            <div class="sk-cube sk-cube6"></div>
            <div class="sk-cube sk-cube7"></div>
            <div class="sk-cube sk-cube8"></div>
            <div class="sk-cube sk-cube9"></div>
        </div>
    </div>    
{:then researchData}
    <div in:fade={{ easing: quintOut, duration: 1000 }}>
        {#each researchData as category}
            {@const filteredList = category.items.filter(item => item.id == id)}
            {@const currentItem = (filteredList.length > 0) ? filteredList[0] : false}
            {@const categoryImagePromise = (currentItem) ? loadImageWithFallback(`/images/backgrounds/research/${category.category.replace(/\s/g, '-').toLowerCase()}`, `/images/research/default.jpg`, false) : false}
        

            {#if currentItem}
                {#await categoryImagePromise then src}
                    <div class="top-background" style="background-image:url({src}); height: auto; min-height: 35vh;">
                        <h1 class="page-title" style="text-transform:capitalize;">{@html currentItem.name}</h1>
                    </div>
                {/await}

                <div class="content">
                    <section id="research-details">

                        <div class="flex-wrapper">
                            <div class="flex-column first">
                                <!-- Project Image -->
                                {#if currentItem.imageSrc}
                                    <img src={currentItem.imageSrc} class="project-picture" alt="Project">
                                {:else}
                                    <img src="/images/research/default.jpg" class="project-picture" alt="Project Default">
                                {/if}

                                <!-- Project Team -->
                                {#if currentItem.team}
                                    <h3 class="subtitle">Project Team</h3>
                                    <ul class="card-list">
                                        {#if currentItem.team}
                                            {#each currentItem.team as person}
                                                <li>{@html person}</li>
                                            {/each}
                                        {/if}
                                    </ul>
                                {/if}
                            </div>

                            <div class="flex-column secondary">
                                <!-- Summary  -->
                                <p>{@html currentItem.summary}</p><br>

                                <!-- Collaborators -->
                                {#if currentItem.collaborators}
                                    <h3 class="subtitle">Collaborators</h3>
                                    <div class="image-container">
                                        {#each currentItem.collaborators as src}
                                            <img {src} alt="Collaborator">
                                        {/each}
                                    </div>
                                {/if}

                                <!-- Publications -->
                                {#if currentItem.publications}
                                    {#each currentItem.publications as pubItem}
                                        <div class="detail-wrapper">
                                            <h3 class="subtitle">{@html pubItem.category}</h3>
                                            
                                            {#if Array.isArray(pubItem.items)}
                                                <ul>
                                                    {#each pubItem.items as publication}
                                                        <li>{@html publication}</li>
                                                    {/each}
                                                </ul>
                                            {:else}
                                                <p>{@html pubItem.items}</p>
                                            {/if}
                                        </div>
                                    {/each}
                                {/if}
                            </div>
                        </div>
                    </section>
                </div>
            {/if}
        {/each}

        {#if noResults}
            <div class="content">
                <div class="no-results-container">
                    <img src="/images/icons/no-results.png" alt="no results">
                    <h3>Sorry, this project doesn't exist.</h3>
                </div>
            </div>
        {/if}
    </div>

{/await}



<style lang="sass">

@import "../consts.sass"
@include page-header()
@include loading-spinner()
@include action-button()
@include no-search-results-text()

.content
    padding: 2em
    box-sizing: border-box

    @media only screen and (min-width: 1200px) 
        padding-right: 10vw
        padding-left: 10vw

    .flex-wrapper
        margin-top: 3rem
        display: flex
        flex-direction: row
        justify-content: flex-start

        ul.card-list
            list-style-type: none
            margin: 0
            margin-top: 1.5rem

            li
                border-radius: 0.3rem
                border: 1px solid rgba(0,0,0,0.2)
                font-size: 1rem
                padding: 0.4rem 0.7rem
                box-sizing: border-box
                margin-top: 0.5rem

        .image-container
            display: flex
            flex-direction: row
            flex-flow: wrap
            margin-top: 2em

            img
                height: 6em
                margin-right: 3em
                margin-bottom: 2.5em
                border-radius: 0.2em

        img.project-picture
            border-radius: 0.2rem

        @media only screen and (max-width: 1200px) 
            flex-direction: column
            flex-flow: wrap

            img.project-picture
                width: 22em

            .flex-column.secondary
                margin-top: 2em
        
        @media only screen and (min-width: 1200px) 
            img.project-picture
                max-width: 30em
            
            .flex-column.secondary
                margin-left: 5em
    

</style>